import useMedia from 'use-media';

export const useIsMobile = () => useMedia({ maxWidth: 767 });
export const useIsTablet = () => useMedia({ minWidth: 768, maxWidth: 1079 });
export const useIsDesktop = () => useMedia({ minWidth: 1080 });
